
import Vue, {PropType} from "vue";
import {mapMutations, mapState} from "vuex";

export default Vue.extend({
  name: "PerformanceDisplay",
  components: {},
  props: {
    textTop: {type: String as PropType<string>, default: ""},
    textCenter: {type: String as PropType<string>, default: ""},
    textCenterPrefix: {type: String as PropType<string>, default: ""},
    textCenterSuffix: {type: String as PropType<string>, default: ""},
    textBottom: {type: String as PropType<string>, default: ""},
    title: {type: String as PropType<string>, default: ""},
    performanceChange: {type: String as PropType<string>, default: ""},
  },
  data() {
    return {};
  },
  created() {
  },
  watch: {},
  computed: {
    ...mapState(["user", "backendInterface"]),
  },
  methods: {
    ...mapMutations([""]),
  },
});
